import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface GeneralDropdownsTriggersTriggerPowerSelectMeatballsSignature {
  Args: {};
}

const GeneralDropdownsTriggersTriggerPowerSelectMeatballs = <template>
  <div class="trigger__content flex items-center">
    <button class="button--unstyled" title={{t "general.more"}} type="button">
      <PrismIcon @name="meatballs" @size="small" />
    </button>
  </div>
</template> satisfies TOC<GeneralDropdownsTriggersTriggerPowerSelectMeatballsSignature>;

export default GeneralDropdownsTriggersTriggerPowerSelectMeatballs;
